export default __webpack_public_path__ + "static/media/kwik-scout-logo.2a55d4f8.png";